export enum ScoreGraphSize {
  XS = "XS",
  SM = "SM",
  LG = "LG"
}
